import moment from "moment";
export default {
  namespaced: true,
  state: {
    now: moment().format("DD/MM/YYYY HH:mm")
  }
};
